import { render, staticRenderFns } from "./instrumentoComponent.vue?vue&type=template&id=1269459d&"
import script from "./instrumentoComponent.vue?vue&type=script&lang=js&"
export * from "./instrumentoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports